import React from 'react'
import UserResult from '../components/users/UserResult'
import UserSearch from '../components/users/UserSearch'

function Home() {
  return (
    <>
       <UserSearch />
        <UserResult />

    </>
  )
}

export default Home